import React from 'react';
import { Home, Calendar, CalendarDays, Users, Mail } from 'lucide-react';

type Page = 'home' | 'booking' | 'events' | 'membership' | 'contact';

interface MobileNavWrapperProps {
  currentPage: Page;
  onNavigate: (page: Page) => void;
}

const pageMap: { page: Page; label: string; icon: React.ElementType }[] = [
  { page: 'home', label: 'Home', icon: Home },
  { page: 'booking', label: 'Buchen', icon: Calendar },
  { page: 'events', label: 'Events', icon: CalendarDays },
  { page: 'membership', label: 'Mitglied', icon: Users },
  { page: 'contact', label: 'Kontakt', icon: Mail },
];

const MobileNavWrapper: React.FC<MobileNavWrapperProps> = ({ currentPage, onNavigate }) => {
  return (
    <nav className="mobile-premium-nav" role="navigation">
      {pageMap.map(({ page, label, icon: Icon }) => {
        const active = currentPage === page;
        return (
          <button
            key={page}
            className={`mobile-nav-item${active ? ' mobile-nav-item--active' : ''}`}
            onClick={() => onNavigate(page)}
            aria-label={label}
          >
            <span className="mobile-nav-icon-wrap">
              <Icon className="mobile-nav-icon" />
              {active && <span className="mobile-nav-dot" />}
            </span>
            <span className="mobile-nav-label">{label}</span>
          </button>
        );
      })}
    </nav>
  );
};

export default MobileNavWrapper;
